/**
 * Split assistant text for inline preview paywall (Phase 6C).
 * Backend `responseStage === 'preview'` is the source of truth.
 */

export function buildPaywallPreviewParts(text, billing) {
  const safeText = String(text || '');
  const stage = billing?.responseStage || billing?.softGate?.stage;
  if (stage !== 'preview') {
    return { visiblePart: safeText, hiddenPart: '', isPreview: false };
  }
  const cut = Math.min(800, Math.max(160, Math.floor(safeText.length * 0.42)));
  if (safeText.length <= cut + 24) {
    return { visiblePart: safeText, hiddenPart: '', isPreview: true };
  }
  return {
    visiblePart: safeText.slice(0, cut),
    hiddenPart: safeText.slice(cut),
    isPreview: true,
  };
}
